import { useEffect } from 'react';
import { useLoadCompany } from 'shared/hooks/use-load-company';
import apiService from 'shared/service/api.service';
import { Environment, getEnv, isOneOfEnvs } from 'shared/utils/environment';

import { useProfile } from './use-enforce-profile';

export function useBootIntercom() {
  const profile = useProfile();
  const { company: companyV2 } = useLoadCompany()!;

  useEffect(() => {
    if (
      companyV2 != null &&
      profile != null &&
      window.Intercom != null &&
      isOneOfEnvs(Environment.PRODUCTION, Environment.DEMO)
    ) {
      window.Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: __INTERCOM_APP_ID__,
        name: profile.name.full,
        company: {
          id: companyV2?.id,
          name: `${companyV2.name}${
            companyV2.name.toLowerCase() === apiService.tenant ? '' : `(${apiService.tenant})`
          }`,
        },
        user_id: profile.id,
        email: profile.email,
        environment: getEnv(),
        user_hash: profile.intercomHash,
      });
      window.Intercom('update', { z_index: 9, vertical_padding: 60 });
    }
  }, [profile, companyV2]);
}
